import { h } from 'preact'
import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'
import classNames from 'classnames'

const twelveHours = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']

const minutesByQuorter = ['00', '15', '30', '45']

const makeItemsList = (items: Array<string>, callback: CallableFunction) => items.map(item => ({
  title: item,
  onClick: (e: ClickEvent) => callback(e.target.textContent)
}))

interface Props {
  hours?: string,
  minutes?: string,
  period?: string,
  onHoursChange: CallableFunction,
  onMinutesChange: CallableFunction,
  onPeriodChange: CallableFunction,
  error?: boolean,
  classes?: Array<string>
}

const Timepicker = ({ hours, minutes, period, onHoursChange, onMinutesChange, onPeriodChange, error, classes }: Props) => {
  const additionalClasses = classes || []
  return <div className={classNames({ 'validation-error': error }, 'insided-timepicker', ...additionalClasses)}>
    <DropdownControl triggerClass={'qa-timepicker-hours'} align='adjust' items={makeItemsList(twelveHours, onHoursChange)} trigger={
      <ButtonControl class={hours ? 'selected' : 'default'} title={hours || '-'} icon={'arrowDropdown'} />
    } />
    :
    <DropdownControl triggerClass={'qa-timepicker-minutes'} align='adjust' items={makeItemsList(minutesByQuorter, onMinutesChange)} trigger={
      <ButtonControl class={minutes ? 'selected' : 'default'} title={minutes || '-'} icon={'arrowDropdown'} />
    } />
    <DropdownControl triggerClass={'qa-timepicker-period'} align='adjust' items={makeItemsList(['AM', 'PM'], onPeriodChange)} trigger={
      <ButtonControl class={period ? 'selected' : 'default'} title={period || '-'} icon={'arrowDropdown'} />
    } />
  </div>
}

export default Timepicker
